const config = {};

config.SetFeedbackCoreConfig = (conf) => {
  Object.assign(config, conf);
};

module.exports = config;
